import React from "react"
import PropTypes from "prop-types"
import { TeaserList } from "@bw/partials"
import { Grid } from "../../bits"

const Links = ({ links }) => {
  return (
    <Grid columns={1}>
      {links.map(
        ({ url, entry, isExternal, openInModal, linkText, description }, i) => (
          <TeaserList
            key={i}
            isExternal={isExternal}
            modal={openInModal}
            to={entry?.url}
            href={url}
            title={linkText}
            subtitle={description}
          />
        )
      )}
    </Grid>
  )
}

Links.propTypes = {
  links: PropTypes.array,
}

export { Links }
